import { captureMarketingAttribution } from "@/app/router/marketing-attribution";
import { electronModule } from "@/modules/electron";
import { logger } from "@/modules/logger";
import { objectModule } from "@/modules/object";

/**
 * Hydrates the renderer from Electron before auth and keeps accepting late handoffs.
 *
 * Subscribing before the initial read makes the read/update race harmless:
 * both paths merge the same journey idempotently into renderer local storage.
 */
export const initializeDesktopMarketingAttributionHandoff = async (): Promise<void> => {
  try {
    await electronModule.onMarketingAttribution(attribution => {
      captureMarketingAttribution({ attribution });
    });
  } catch (unknownError) {
    logger.warn({
      message: "[desktopMarketingAttributionHandoff] Failed to subscribe.",
      info: { error: objectModule.safeErrorAsJson(unknownError as Error) },
    });
  }

  try {
    const attribution = await electronModule.getMarketingAttribution();
    if (attribution !== null) {
      captureMarketingAttribution({ attribution });
    }
  } catch (unknownError) {
    logger.warn({
      message: "[desktopMarketingAttributionHandoff] Failed to hydrate.",
      info: { error: objectModule.safeErrorAsJson(unknownError as Error) },
    });
  }
};
